import { surveyLibraryStore } from "../stores/survey-library.store";

export const useSurveyLibraryStore = () => surveyLibraryStore;
